import InventoryManagement from './InventoryManagement';
import InventoryManagementHOC from './InventoryManagementHOC';

export default InventoryManagementHOC(InventoryManagement);



// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/index.jsx